<!--  -->
<template>
  <div>

    <el-form :model="uploadForm" ref="upload" :rules="rules" label-width="80px" label-position="right">
      <el-form-item prop="files" label="选择文件">
        <el-upload ref="upload"  name="file" :on-change="handleChange" :file-list="fileList" action="" :http-request="httpRequest" :on-remove='removeList' class="multiple_upload">
          <el-input style="100%;" readonly></el-input>
        </el-upload>
      </el-form-item>
      <el-form-item prop="docComments" label="文件描述">
        <el-input style="width:100%;" maxlength="1000"  placeholder="" v-model="uploadForm.docComments"></el-input>
      </el-form-item>
      <el-form-item prop="fileType" label="文件类型">
        <el-select v-model="uploadForm.fileType"   clearable style="width:100%;" placeholder="请选择">
          <el-option :key="index" v-for="(item,index) in fileTypeList" :label="item.name" :value="item.code">
            <span v-if="item.isMust" style="float: left;color:red;">*</span>
            <span style="margin-left:5px;">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary"  @click="uploading('ruleForm')">上传</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import ratingTask from "@/api/AAA/ratingTask.js";
import { fileService } from "@/api/common/file-utils"
import prot3p from '@/api/rmcProtein/prot3p'
import QBRApi from "@/api/QBR/index";


export default {
  props:['url','detailInfo'],
  data () {
    return {
      fileList:[],
      fileData:[],
       uploadForm: {
          files: [],
          docComments:"",
          fileType:"",
        },
        fileTypeList:[],
        rules: {
          files: [
            { required: true, message: '请上传文件', trigger: 'blur' },
          ],
          docComments: [
            { required: true, message: '请输入文件描述', trigger: 'blur' },
          ],
          fileType: [
            { required: true, message: '请选择文件类型', trigger: 'change' },
          ],
        },
    };
  },

  components: {IcSelect},
  created(){
    this.getSelector()
    this.getFileLists()
    console.log("ssssssssssss",this.detailInfo)
  },

  computed: {},

  methods: {
    getFileLists() {
      QBRApi.getFileLists({
        tsReckindId: this.detailInfo.auditType=='TRIPARTITE_PARTY_VERIFY_REPORT'?"TRIPARTITY_PARTY_UPLOAD":"SECOND_PARTY_UPLOAD",
        tsRecId: this.detailInfo.ttRmcProteinAuditReportId
      }).then(res => {
        this.fileData = res
      });
    },
    httpRequest(param){
      this.uploadForm.files.push(param.file)
    },
    handleChange(file, fileList) {
       this.fileList = fileList.slice(-1);
       if (fileList.length > 1) {
            // this.uploadForm.files = [fileList[fileList.length - 1]]  
            this.uploadForm.files.splice(0,1)
       }
    },
    getSelector(){
      console.log("sssssss",this.detailInfo)
      prot3p.getSelector().then((res)=>{
        if(this.detailInfo.auditType=='TRIPARTITE_PARTY_VERIFY_REPORT'){   //3方
          res.data.fileUploadType.forEach((v)=>{
            let obj={}
            obj.name=v
            obj.code=v
            this.fileTypeList.push(obj)
          })
          if(this.detailInfo.category3Code==10101){  //poultry
            this.fileTypeList.forEach((v)=>{
              if(this.detailInfo.aslAuditDate && (v.code=='GMP'||v.code=='HACCP'||v.code=='Antibiotics'||v.code=='Animal Walfare'||v.code=='ASL整改'  )  ){
                v.isMust=true
              }else{
                v.isMust=false
              }
              if(this.detailInfo.swaAuditDate&& (v.code=='SCHR' ||v.code=='SCHR整改' )){
                v.isMust=true
              }
            })
          }else{
            this.fileTypeList.forEach((v)=>{
              if(this.detailInfo.aslAuditDate && (v.code=='GMP'||v.code=='HACCP'||v.code=='Animal Walfare'||v.code=='ASL整改')  ){
                v.isMust=true
              }else{
                v.isMust=false
              }
              if(this.detailInfo.swaAuditDate&& (v.code=='SCHR'||v.code=='SCHR整改')){
                v.isMust=true
              }
            })
          }
        }else{
          res.data.fileUploadType.forEach((v)=>{
            let obj={}
            obj.name=v
            obj.code=v
            this.fileTypeList.push(obj)
          })
          this.fileTypeList.forEach((v)=>{
            if(v.code=='GMP'||v.code=='ASL整改'){
              v.isMust=true
            }else{
              v.isMust=false
            }
          })
        }
      })
    },
    uploading(){
      this.$refs['upload'].validate((valid) => {
        if (valid) {
            let formData = new FormData();
            this.uploadForm.files.forEach((v)=>{
                formData.append('file',v,v.name)
            })
            fileService.fileUpload(formData).then((res) => {
              res.data[0].userName=res.data[0].uploadBy
              res.data[0].createDate=res.data[0].uploadTime

              // let str=this.uploadForm.docComments+'-'+this.uploadForm.fileType
              // let index=str.lastIndexOf('-')
              // console.log(str.substring(index+1,str.length))
              // console.log(str.split('-'+str.substring(index+1,str.length))[0])

              this.uploadForm.docComments=this.uploadForm.docComments+'-'+this.uploadForm.fileType
              this.$emit('close',this.uploadForm,res.data)

                
                // let attachment = {};
                // attachment.documents = res.data;
                // attachment.documents[0].docComments=this.uploadForm.docComments+'-'+this.uploadForm.fileType
                // attachment.seq = '1';
                // attachment.tsRecId =this.detailInfo.ttRmcProteinAuditReportId;
                // attachment.tsReckindId = this.detailInfo.auditType=='TRIPARTITE_PARTY_VERIFY_REPORT'?"TRIPARTITY_PARTY_UPLOAD":"SECOND_PARTY_UPLOAD";
                // fileService.saveFile(attachment).then((saveRes) => {
                //     if(saveRes.code==200){
                //         this.$message.success('保存成功')
                //         this.$emit('close')
                //     }else{
                //         this.$message.error(res.msg)
                //     }
                // })
            }).catch((error) => {
            //文件上传失败
              this.$message.error('文件上传失败')
            });
        }
      })
    },
    removeList(file, fileList){
      this.uploadForm.files=fileList
      if(fileList.length==0){
        this.uploadForm.files=[]
      }
    },
    close(){
      this.$emit('close')
    }
  }
}

</script>
<style  scoped>
</style>
